import React, { useState } from "react";
import { workspaceValidation } from "../../schemas";
import PrimaryModal from "../UI/Modal/PrimaryModal";
import { Form, Formik } from "formik";
import { FormikInput, SecondaryButton, PrimaryButton } from "../UI";
import { addNewWorkspace, updateWorkspace } from "../../utils/APIs";
import { useUserContext } from "../../contexts/UserContext";
import Loader from "../UI/Loader/Loader";
import { useContentfulContext } from "../../contexts/ContentfulContext";

const AddUpdateWorkspaceModal = ({
  setOpenAddUpdateWorkspaceModal,
  handleClose,
  workspaceData,
}) => {
  const { userData, updateWorkspaces } = useUserContext();
  const { content } = useContentfulContext();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const data = {
        workspace_name: values.workspace_name,
        workspace_id: values.workspace_id
      };

      if (workspaceData?._id) {
        await updateWorkspace(
          userData.token,
          userData.selectedOrganization.org_token,
					workspaceData._id,
          data
        );
      } else {
         await addNewWorkspace(
          userData.token,
          userData.selectedOrganization.org_token,
          data
        );
      }

      updateWorkspaces();

      setError("");
      handleClose(workspaceData ? content.WORKSPACE_MANAGEMENT_CONTENT.success.edit : content.WORKSPACE_MANAGEMENT_CONTENT.success.add);
    } catch (error) {
      setLoading(false);
      setError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
    }
  };

  return (
    <>
      <PrimaryModal
        title={workspaceData?.workspace_id ? content.WORKSPACE_MANAGEMENT_CONTENT.modal.edit_title : content.WORKSPACE_MANAGEMENT_CONTENT.modal.add_title}
        hideModal={() => setOpenAddUpdateWorkspaceModal(false)}
        widthClass="max-w-2xl"
      >
        {loading && <Loader />}

        <div className="p-7 pt-1 space-y-6">
          <Formik
            initialValues={{
              workspace_id: workspaceData?.workspace_id || "",
              workspace_name: workspaceData?.workspace_name || "",
            }}
            validationSchema={() => workspaceValidation(content.WORKSPACE_MANAGEMENT_CONTENT)}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form action="#" className="pr-3 space-y-4">
                <FormikInput
                  type="number"
                  id="workspace_id"
                  name="workspace_id"
                  label={content.WORKSPACE_MANAGEMENT_CONTENT.modal.form.workspace_id}
                  disabled={Boolean(workspaceData?.workspace_id)}
                />
                <FormikInput
                  type="text"
                  id="workspace_name"
                  name="workspace_name"
                  label={content.WORKSPACE_MANAGEMENT_CONTENT.modal.form.workspace_name}
                />
                {error && <p className="mt-2 text-sm text-red-5">{error}</p>}
                <div className="flex justify-end gap-2 pt-2">
                  <SecondaryButton handleClick={() => {
                    setOpenAddUpdateWorkspaceModal(false);
                  }}>{content.WORKSPACE_MANAGEMENT_CONTENT.modal.cancel_btn}</SecondaryButton>
                  <PrimaryButton type="submit">{content.WORKSPACE_MANAGEMENT_CONTENT.modal.submit_btn}</PrimaryButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </PrimaryModal>
    </>
  );
};

export default AddUpdateWorkspaceModal;
